import { render, staticRenderFns } from "./copy_from_ticket.vue?vue&type=template&id=59cb27ba&"
import script from "./copy_from_ticket.vue?vue&type=script&lang=js&"
export * from "./copy_from_ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports